import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

const POLL_INTERVAL = 2000

export default class extends Controller {
  static get targets() { return ["holder", "loader"]; }
  static get values() { return { complete: Boolean }; }

  connect() {
    this.complete = this.completeValue
    this.syncLoader()
    this.schedulePoll()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedulePoll() {
    this.timer = setTimeout(() => this.checkIfComplete(), POLL_INTERVAL)
  }

  checkIfComplete() {
    if (this.complete) { return; }

    // The show actions serve the label as JSON only when asked for it; $http asked by default.
    const options = RequestHelper.defaultRequestOptions()
    options.headers = Object.assign({}, options.headers, { "Accept": "application/json" })

    fetch(window.location.pathname, options).
      then(response => {
        if (!response.ok) { throw new Error(`Shipping label lookup failed (${response.status})`); }
        return response.json()
      }).
      then(shippingLabel => {
        this.complete = shippingLabel.format_generation_complete
        if (this.complete) {
          // links_html is our own server-rendered markup -- Suppliers::ShippingLabelsController#show
          // (show.json.jbuilder) serializes ShippingLabelDecorator#links_html, which renders the
          // suppliers/shipping_labels/_postage_label_links partial (plain link_to tags to our own
          // png/pdf/zpl urls, no request-derived content).
          this.holderTarget.outerHTML = shippingLabel.links_html
          this.syncLoader()
        } else {
          this.schedulePoll()
        }
      }).
      catch(this.logFailedCall)
  }

  syncLoader() {
    if (!this.hasLoaderTarget) { return; }

    this.loaderTarget.style.display = this.complete ? "none" : ""
  }

  logFailedCall(response) {
    console.warn(response)
  }
}
